angular.module('ui.user.settings', [])

    .config(function ($stateProvider, customTemplateResolverProvider) {

        $stateProvider.state('client.settings', {
            url: '/settings',
            template: customTemplateResolverProvider.get('settings.html', 'app/ui/user/settings/settings.html'),
            controller: 'UserSettingsController',
            data: {pageTitle: 'OrderManager: User Settings'}
        });

    })

    .controller('UserSettingsController', function ($scope, $state, gettextCatalog, toastr, userSettings, gridTextSearchService) {
        $scope.tabs = [
            "app/ui/user/settings/tabs/gridSettings.html",
            "app/ui/user/settings/tabs/otherSettings.html"
        ];

        $scope.settings = userSettings.settings;

        $scope.treeDataSource = kendo.observableHierarchy(userSettings.settings.gridSettings.textSearchFields);
        $scope.treeOptions = {
            checkboxes: {
                checkChildren: true
            }
        };

        $scope.save = function () {
            userSettings.settings.gridSettings.textSearchFields = $scope.treeDataSource.toJSON(); // black Kendo magic
            userSettings.save();
            gridTextSearchService.fixGridTextSearchConfig(); // to delete empty `items` collections
            $state.go('client.home'); // redirect back to home
            toastr.success(gettextCatalog.getString('User settings saved!'));
        };

        $scope.cancel = function () {
            userSettings.reload();
            $scope.treeDataSource = kendo.observableHierarchy(userSettings.settings.gridSettings.textSearchFields);
            $state.go('client.home'); // redirect back to home
        };
    })

;